// NewZealandCompanyRegistration.jsx - FIXED with AUCKLAND SKYLINE IMAGE
import React from "react";

export default function NewZealandCompanyRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            New Zealand Company Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            New Zealand Company Registration - Companies Office
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists with New Zealand Company Registration under Companies Office regulations via RealMe.
          </p>
          <p className="text-gray-700">
            Complete incorporation including name reservation, resident director appointment, registered office setup, consent forms, NZBN issuance within hours.[web:1]
          </p>
        </div>

        {/* Right: AUCKLAND SKYLINE - Perfect for NZ Companies Office registration */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100 bg-gradient-to-br from-gray-100 to-gray-200">
            <img
              src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&h=1200&fit=crop&crop=entropy&auto=format&q=85"
              alt="Auckland New Zealand skyline Sky Tower for Companies Office registration"
              className="w-full h-[400px] md:aspect-square object-cover block"
              loading="eager"
              onError={(e) => {
                e.target.src = "https://images.unsplash.com/photo-1542874544-225ff0d3a497?w=1200&h=1200&fit=crop&auto=format&q=85";
              }}
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for NZ Company Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks prepares complete documentation for Companies Office approval.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Director/shareholder details (names, addresses, consents, resident director proof)</li>
                <li>Registered address (physical NZ office address verification)</li>
                <li>Identity proof (passport copies, RealMe verified identity)</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Proven expertise in NZ Companies Office with resident director solutions.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  NZ Incorporation Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete Companies Office knowledge: RealMe setup, name reservation, resident director rules, consent processing, NZBN compliance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Online Filings
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise application preparation, director consents, office validation, share structure docs, instant Companies Register approvals.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end from RealMe creation to Certificate of Incorporation, IRD numbers, GST registration, bank intros, first-year compliance.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
